import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const API_BASE = process.env.REACT_APP_URL;

export default function GoogleSetPassword() {
  const navigate = useNavigate();

  const googleEmail = localStorage.getItem("googleEmail");
  const googleNameStored = localStorage.getItem("googleName");
  const googlePicture = localStorage.getItem("googlePicture");

  const [name, setName] = useState(googleNameStored || "");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");

  if (!googleEmail) {
    return <h3 style={{ textAlign: "center", marginTop: "50px" }}>Invalid session</h3>;
  }

  const handleSubmit = async () => {
    if (!name) return setError("Full name required");
    if (!password || !confirm) return setError("Enter both password fields");
    if (password !== confirm) return setError("Passwords do not match");

    try {
      console.log("Google register URL:", `${API_BASE}/google-register`);

      const res = await fetch(`${API_BASE}/google-register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: googleEmail,
          username: name,
          password,
        }),
      });

      const data = await res.json();

      if (!res.ok) {
        setError(data.error);
        return;
      }

      localStorage.setItem("userEmail", googleEmail);
      localStorage.setItem("userName", name);
      localStorage.setItem("userPicture", googlePicture || "");

      navigate("/DetectorApp");

    } catch (err) {
      console.error(err);
      setError("Server error");
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <h2>Complete Google Signup</h2>
        <p>You're almost done. Please finish your account setup.</p>

        {googlePicture && (
          <img src={googlePicture} alt="" style={styles.pic} />
        )}

        {error && <p style={styles.error}>{error}</p>}

        <input
          type="email"
          value={googleEmail}
          style={styles.input}
          readOnly
        />

        <input
          type="text"
          placeholder="Full name"
          style={styles.input}
          value={name}
          onChange={(e) => setName(e.target.value)}
        />

        <input
          type="password"
          placeholder="Create password"
          style={styles.input}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <input
          type="password"
          placeholder="Confirm password"
          style={styles.input}
          value={confirm}
          onChange={(e) => setConfirm(e.target.value)}
        />

        <button style={styles.button} onClick={handleSubmit}>
          Continue
        </button>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    background: "#f2f4ff",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  card: {
    width: "360px",
    padding: "25px",
    background: "#fff",
    borderRadius: "12px",
    textAlign: "center",
    boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
  },
  input: {
    width: "100%",
    padding: "12px",
    marginTop: "12px",
    borderRadius: "8px",
    border: "1px solid #ccc",
    fontSize: "15px",
  },
  button: {
    width: "100%",
    padding: "12px",
    marginTop: "18px",
    background: "#636CCB",
    color: "white",
    border: "none",
    borderRadius: "8px",
    fontSize: "16px",
    cursor: "pointer",
  },
  error: { color: "red", marginTop: "10px" },
  pic: {
    width: "60px",
    height: "60px",
    borderRadius: "50%",
    marginBottom: "10px",
  },
};
